

export class FormulaPlan {
    constructor({
          id= null, 
          planCode= ``, 
          planTime= ``, 
          createTime= ``,
          locName='',
          createUser='',
          planStatus='',
          locId = '',
                   
      } = {}) {
      this.id = id;
      this.planCode = planCode;
      this.planTime = planTime;
      this.createTime = createTime;
      this.locName =locName;
      this.createUser = createUser;
      this.planStatus = planStatus;
      this.locId = locId;
          
    }
  }
  export function gridFields() {
    return Object.freeze([ 
        {
            key: 'planCode',
            label: 'lbl.formulaPlan.planCode',
            filterable: true,
            sortable: true,
            uneditable:true,
            form: {
              type: 'input'
            }
        },
        {
          key: 'planTime',
          label: 'lbl.formulaPlan.planTime',
          filterable: true,
          sortable: true,
          form: {
            type: 'datepicker'
          }
        },
        {
          key: 'createTime',
          label: 'lbl.formulaPlan.createTime',//计划创建日期
          filterable: true,
          uneditable: true,
          sortable: true,
          form: {
            type: 'datepicker',
          }
        },
        {
          key: 'locName',
          label: 'lbl.formulaPlan.locationName',
          filterable: true,
          sortable: true,
          form: {
            type: 'select',
            options: [           
              { value: 'Q1', text:  'lbl.basic.plant.pelletizing1' },  
              { value: 'Q2', text:  'lbl.basic.plant.pelletizing2' },
              { value: 'Q3', text:  'lbl.basic.plant.pelletizing3' },               
            ]     
          }
        },
        {
          key: 'createUser',
          label: 'lbl.formulaPlan.createUser',
          filterable: true,
          sortable: true,
          uneditable:true,
          form: {
            type: 'input',
          }
        },
        // {
        //   key: 'planStatus',
        //   label: 'lbl.formulaPlan.planStatus',
        //   filterable: false,
        //   sortable: true,
        //   uneditable:true,
        //   form: {
        //     type: 'select',
        //     options: [               
        //       { value: 'E', text:  'lbl.formulaPlan.planStatus.edit' },  
        //       { value: 'S', text:  'lbl.formulaPlan.planStatus.send' },
        //       { value: 'A', text:  'lbl.formulaPlan.planStatus.save' },               
        //     ]     
        //   }
        // },
        {
          key: 'locId',
          label: 'lbl.formulaPlan.createUser',
          filterable: false,
          sortable: true,
          uneditable:true,
          notInTable :true,
          form: {
            type: 'input',
          }
        }
  
    ]);
  }
  export const filter = gridFields()
  .filter(v => v.filterable)
  .reduce((tar, v) => {
    tar[`${v.key}Filter`] = '';
    return tar
  }, {})
export const filterFields = gridFields().filter(v => v.filterable).map(v => `filter.${v.key}`)